import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { ViewStream } from "@mui/icons-material";

/**
 * Split In Batches Node — Processar lista em lotes.
 *
 * data.batchSize: number — tamanho de cada lote (default 10)
 * data.sourceVar: string — variavel contendo a lista
 * data.batchItemVar: string — nome da variavel para o lote atual
 *
 * Saidas: handle "batch" (executa para cada lote), handle "done" (apos terminar)
 */
const SplitBatchNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const batchSize = data?.batchSize || 10;
  const sourceVar = data?.sourceVar || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<ViewStream />}
      title="Lotes"
      color="#5C6BC0"
      bgColor="#E8EAF6"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px",
        fontSize: 11, fontFamily: "'Fira Code', monospace",
      }}>
        <span style={{ color: "#999" }}>split </span>
        <span style={{ color: "#1565C0", fontWeight: 600 }}>${"{" + sourceVar + "}"}</span>
        <span style={{ color: "#999" }}> em lotes de </span>
        <span style={{ color: "#5C6BC0", fontWeight: 600 }}>{batchSize}</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#5C6BC0", borderRadius: 4, padding: "2px 10px",
          }}>CADA LOTE</span>
          <Handle type="source" position={Position.Right} id="batch"
            className={getHandleClass("source", "batch")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4, padding: "2px 10px",
          }}>CONCLUIDO</span>
          <Handle type="source" position={Position.Right} id="done"
            className={getHandleClass("source", "done")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
      </div>
    </NodeWrapper>
  );
});

SplitBatchNode.displayName = "SplitBatchNode";
export default SplitBatchNode;
